import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { type HeadingOneElement } from '~/components/organism/PluginsEditor/types';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import serializeHeading from '../../../utils/serialize/serializeHeading';

export type Props = RenderElementProps & {
  element: HeadingOneElement;
};

const HeadingOne: React.FCC<Props> = ({ attributes, element, children }) => (
  <Container {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.h1<{}>`
  margin: 0;
`;

export default {
  renderComponent: props => <HeadingOne {...props} />,
  nodeName: 'H1',
  deserialize: () => ({
    type: ELEMENTS.H1,
  }),
  serialize: (node: HeadingOneElement, children) =>
    serializeHeading('h1', children),
};
